<template lang="pug">
  .root
    ArchiveBase(:liveType="liveType")

</template>

<style src="./ArchiveNormal.scss" lang="scss" scoped>

</style>

<script>
import ArchiveBase from './components/ArchiveBase'
import {LIVE_TYPE} from './helper/def'

export default {
  name: "ArchiveLiveNormal",
  components: {
    ArchiveBase
  },
  data() {
    return {
      liveType: LIVE_TYPE.NORMAL
    }
  },
  props: {},
  computed: {},
  watch: {},
  mounted() {},
  async created() {},
  updated() {},
  async destroyed() {},
  methods: {}
};
</script>
